import { Img, Text } from "components";
import React from "react";
import { useTranslation } from "react-i18next";
import Account from "./Account";
import Payment from "./Payment";

const AddMoney = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex flex-col w-full">
        <Text
          className="text-[24px] font-semibold leading-[32px] text-start font-['Inter'] text-[var(--Blacks-900,#1A1A1A)] mb-5 sm:text-[18px]"
        >
          {t("addingWalletBalance")}
        </Text>

        <div className="w-full bg-[white] border border-gray-200 rounded-xl px-6 py-5 xs:px-4">
          <Text
           className="text-[20px] font-medium leading-[28px] font-['Inter'] text-[var(--Blacks-900,#1A1A1A)] mb-4 sm:text-[16px]"
          >
            {t("paymentDetails")}
          </Text>

          <Account {...props} />

          <div className="h-px bg-gray-100 my-5 -mx-6 xs:-mx-4" />

          <Payment {...props} />
        </div>
      </div>
    </>
  );
};

export default AddMoney;